
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/dates-fermeture-stations",
      function () {
        return require("private-next-pages/[region]/dates-fermeture-stations.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/dates-fermeture-stations"])
      });
    }
  